import { PropOptionSelect, PropOptionRadio } from '@/models'

const MALE = 1
const FEMININE = 2

const WORK_TYPE_LABORER = 1
const WORK_TYPE_PIECEWORK = 2

const TYPE_REGIME_AFP = 2
const TYPE_REGIME_ONP = 1
const TYPE_REGIME_NOT_APPLY = 0

const optionsBanks: PropOptionSelect[] = [
    {
        value: '1',
        text: 'Banco Azteca'
    },
    {
        value: '2',
        text: 'BBVA'
    },
    {
        value: '3',
        text: 'Banco de Comercio'
    },
    {
        value: '4',
        text: 'Banco de Crédito del Perú'
    },
    {
        value: '5',
        text: 'Banco de la Nación'
    },
    {
        value: '6',
        text: 'Banco Falabella'
    },
    {
        value: '7',
        text: 'Banco GNB Perú'
    },
    {
        value: '8',
        text: 'Banco Interamericano de Finanzas (BanBif)'
    },
    {
        value: '9',
        text: 'Bank of China'
    },
    {
        value: '10',
        text: 'Banco Pichincha'
    },
    {
        value: '11',
        text: 'Banco Ripley'
    },
    {
        value: '12',
        text: 'Banco Santander Perú'
    },
    {
        value: '13',
        text: 'Cencosud Scotia'
    },
    {
        value: '14',
        text: 'Citibank Perú'
    },
    {
        value: '15',
        text: 'ICBC PERU BANK'
    },
    {
        value: '16',
        text: 'Interbank'
    },
    {
        value: '17',
        text: 'MiBanco'
    },
    {
        value: '18',
        text: 'Scotiabank Perú'
    }
]

const optionsWorkType: PropOptionSelect[] = [
    {
        text: 'Jornal',
        value: WORK_TYPE_LABORER
    },
    {
        text: 'Destajo',
        value: WORK_TYPE_PIECEWORK
    }
]

const optionsSemestre: PropOptionSelect[] = [
    {
        text: 'MAYO - OCTUBRE',
        value: 1
    },
    {
        text: 'NOVIEMBRE - ABRIL',
        value: 2
    }
]

const optionsSemestre2: PropOptionSelect[] = [
    {
        text: 'JULIO - Fiestas Patrias',
        value: 1
    },
    {
        text: 'DICIEMBRE - Navidad',
        value: 2
    }
]

const optionsTelecredito: PropOptionSelect[] = [
    {
        text: 'BCP',
        value: 1
    },
    {
        text: 'Interbank',
        value: 2
    }
]

const optionsTipocuenta: PropOptionSelect[] = [
    {
        text: 'CORRIENTE',
        value: 1
    },
    {
        text: 'MAESTRA',
        value: 2
    },
    {
        text: 'AHORROS',
        value: 3
    },
    {
        text: 'INTERBANCARIA',
        value: 4
    }
]

const optionsMoneda: PropOptionSelect[] = [
    {
        text: 'Soles',
        value: 1
    },
    {
        text: 'Dólares',
        value: 2
    }
]

const optionsPaymentFrequency: PropOptionSelect[] = [
    {
        text: 'Quincenal',
        value: 'biweekly'
    },
    {
        text: 'Mensual',
        value: 'monthly'
    },
    {
        text: 'Pago Semanal',
        value: 'weekly'
    }
]

const optionsWorkCategory: PropOptionSelect[] = [
    {
        text: 'Obrero - Planilla Operativa',
        value: 1
    },
    {
        text: 'Empleado - Planilla Administrativa',
        value: 2
    }
]

const optionsTypeOfContract: PropOptionSelect[] = [
    {
        text: 'Intermitente',
        value: 1
    },
    {
        text: 'Por necesidad de Mercado',
        value: 2
    },
    {
        text: 'Contrato de Exportación  no tradicional',
        value: 3
    },
    {
        text: 'Contrato Indeterminado',
        value: 4
    }
]

const optionsLaborRegime: PropOptionSelect[] = [
    {
        value: 1,
        text: 'Reg. General 728'
    }
]

const optionsCondition: PropOptionSelect[] = [
    {
        text: 'Indeterminado',
        value: 1
    },
    {
        text: 'Contratado',
        value: 2
    },
    {
        text: 'Practicante',
        value: 3
    }
]

const optionsTypeCommission: PropOptionSelect[] = [
    {
        text: 'Flujo',
        value: 1
    },
    {
        text: 'Mixta',
        value: 2
    }
]

const optionsSctrPension: PropOptionSelect[] = [
    {
        text: 'Mediano riesgo',
        value: 1
    },
    {
        text: 'Alto riesgo',
        value: 2
    }
]

const optionsRegimes: PropOptionRadio[] = [
    {
        value: TYPE_REGIME_ONP,
        text: 'ONP'
    },
    {
        value: TYPE_REGIME_AFP,
        text: 'AFP'
    },
    {
        value: TYPE_REGIME_NOT_APPLY,
        text: 'NO APLICA'
    }
]

const optionsSex: PropOptionSelect[] = [
    {
        text: 'Masculino',
        value: MALE
    },
    {
        text: 'Femenino',
        value: FEMININE
    }
]

const AMOUNT_LUNCH_TYPES = [
    {
        value: 1,
        text: 1
    },
    {
        value: 2,
        text: 2
    }
]

const ajenoOptions = [
    {
        value: 0,
        text: 'No'
    },
    {
        value: 1,
        text: 'SI'
    }
]

const WORK_MODALITY_TYPES = [
    {
        value: 'D',
        text: 'D'
    },
    {
        value: 'J',
        text: 'J'
    }
]

const getTextWorkCategory = (id: number): string => {
    const op = optionsWorkCategory.find(wk => wk.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextWorkType = (id: number): string => {
    const op = optionsWorkType.find(wk => wk.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextTypeOfContract = (id: number): string => {
    const op = optionsTypeOfContract.find(tc => tc.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextCondition = (id: number): string => {
    const op = optionsCondition.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextLaborRegimen = (id: number): string => {
    const op = optionsLaborRegime.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextBank = (id: string): string => {
    const op = optionsBanks.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextPaymentFrecuency = (value: string): string => {
    const op = optionsPaymentFrequency.find(op => op.value === value)
    if (op) {
        return op.text
    }
    return ''
}

const getTextSctrPensionType = (id: number): string => {
    const op = optionsSctrPension.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextRegimes = (id: number): string => {
    const op = optionsRegimes.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

const getTextTypeComission = (id: number): string => {
    const op = optionsTypeCommission.find(op => op.value === id)
    if (op) {
        return op.text
    }
    return ''
}

export {
    optionsCondition,
    optionsWorkType,
    optionsTelecredito,
    optionsSemestre,
    optionsSemestre2,
    optionsTipocuenta,
    optionsMoneda,
    optionsWorkCategory,
    optionsTypeOfContract,
    optionsTypeCommission,
    optionsSctrPension,
    getTextWorkCategory,
    getTextTypeOfContract,
    optionsRegimes,
    optionsLaborRegime,
    optionsBanks,
    optionsPaymentFrequency,
    getTextWorkType,
    optionsSex,
    getTextCondition,
    getTextLaborRegimen,
    getTextBank,
    getTextPaymentFrecuency,
    getTextSctrPensionType,
    getTextRegimes,
    getTextTypeComission,
    MALE,
    FEMININE,
    WORK_TYPE_PIECEWORK,
    WORK_TYPE_LABORER,
    TYPE_REGIME_AFP,
    TYPE_REGIME_ONP,
    TYPE_REGIME_NOT_APPLY,
    AMOUNT_LUNCH_TYPES,
    ajenoOptions,
    WORK_MODALITY_TYPES
}
